import React from "react";

import cx from "classnames";
import { BoltIcon } from "@picklebet/ui";

import * as styles from "./BetTrackerLogo.module.scss";

interface BetTrackerLogoProps {
  isAboveScoreBoard?: boolean;
}

const BetTrackerLogo = ({ isAboveScoreBoard }: BetTrackerLogoProps) => {
  return (
    <div
      className={cx(styles.betTracker, {
        [styles.aboveScoreBoard]: isAboveScoreBoard,
      })}
    >
      <BoltIcon data-animation-class="flash" className={styles.boltIcon} />
      <span className={styles.betTrackerText}>BET TRACKER</span>
    </div>
  );
};

export { BetTrackerLogo };
